<template>
  <div class="main updateMain">
    <!-- 顶部 -->
    <div class="top">
      <img class="goback" src="../assets/back.png" @click="goback" />
      <span>返回</span>
      <span style="margin-left: 40%;color:#00b0f0;font-size: 24px;">补充资料</span>
    </div>
    <!-- 下部分 -->
    <p class="TEXT">如有修改请重新填写，无修改则直接点击下一步。</p>
    <el-form ref="form" :model="form" label-width="180px" style="margin: 40px 0;">
      <el-form-item label="项目概况:" prop="overview">
        <p class="color606266">(不少于200字)</p>
        <el-input
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8}"
          v-model="form.overview"
          style="width: 85%"
        ></el-input>
      </el-form-item>
      <p
        style="height:30px;margin-left: 180px;line-height: 20px;font-size: 14px;"
        class="color606266"
      >
        <i class="el-icon-upload"></i>上传相关图片：
      </p>
      <ImgUploader :fileList="form.overviewPICs" :handleChange="handleChange" />

      <el-form-item label="社会效益和经济效益:" prop="benefit" style="margin-top: 30px;">
        <p class="color606266">(不少于200字)</p>
        <el-input
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8}"
          v-model="form.benefit"
          style="width: 85%"
        ></el-input>
      </el-form-item>
      <p
        style="height:30px;margin-left: 180px;line-height: 20px;font-size: 14px;"
        class="color606266"
      >
        <i class="el-icon-upload"></i>上传相关图片：
      </p>
      <ImgUploader :fileList="form.benefitPICs" :handleChange="handleChange2" />

      <el-form-item label="可操作性和示范性:" prop="operability" style="margin-top: 30px;">
        <p class="color606266">(不少于200字)</p>
        <el-input
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8}"
          v-model="form.operability"
          style="width: 85%"
        ></el-input>
      </el-form-item>
      <p
        style="height:30px;margin-left: 180px;line-height: 20px;font-size: 14px;"
        class="color606266"
      >
        <i class="el-icon-upload"></i>上传相关图片：
      </p>
      <ImgUploader :fileList="form.operabilityPICs" :handleChange="handleChange3" />
    </el-form>
    <div style="text-align: center;margin-bottom: 60px;">
      <el-button type="primary" @click="next">下一步</el-button>
    </div>
  </div>
</template>

<script>
import * as API from '../utils/apiService'
import ImgUploader from '../components/ImgUploader'
export default {
  components: {
    ImgUploader
  },
  data () {
    return {
      form: {
        overview: '',
        benefit: '',
        operability: '',
        overviewPICs: [],
        benefitPICs: [],
        operabilityPICs: []
      }
    }
  },
  methods: {
    goback () {
      this.$router.go(-1)
    },
    next () {
      if (this.form.overview) {
        if (this.form.overview.length < 200) {
          this.$message.error('项目概况至少200字以上')
          return
        }
      }
      if (this.form.benefit) {
        if (this.form.benefit.length < 200) {
          this.$message.error('社会效益和经济效益至少200字以上')
          return
        }
      }
      if (this.form.operability) {
        if (this.form.operability.length < 200) {
          this.$message.error('可操作性和示范性至少200字以上')
          return
        }
      }
      let params = {
        id: this.$route.query.id,
        overview: this.form.overview,
        benefit: this.form.benefit,
        operability: this.form.operability,
        overviewPICs: this.form.overviewPICs,
        benefitPICs: this.form.benefitPICs,
        operabilityPICs: this.form.operabilityPICs
      }
      API.replenishData(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.$router.push(
            '/energy?isSubmitted=true&id=' +
              this.$route.query.id +
              '&isPt=' +
              this.$route.query.isPt
          )
        }
      })
    },
    // 文件改变时，调用上传接口
    handleChange (file) {
      this.form.overviewPICs.push(file)
    },
    handleChange2 (file) {
      this.form.benefitPICs.push(file)
    },
    handleChange3 (file) {
      this.form.operabilityPICs.push(file)
    }
  }
}
</script>

<style lang="scss">
.updateMain {
  .TEXT {
    text-align: center;
    color: #f00;
    font-size: 16px;
  }
}
</style>
